// extracted by mini-css-extract-plugin
module.exports = {"opportunitiesHeader":"userOpportunities_opportunitiesHeader__2xIqj headers_h1__1vThK","opportunities":"userOpportunities_opportunities__uIcMi"};